import BaseComponent from './BaseComponent';
import Toastify      from 'toastify-js';

class Toast extends BaseComponent {
  constructor(componentName){
    super(componentName);  // Params passed to BaseComponent

    this.options = {
      backgroundColor:'#5E6977',
      close: true,
      duration: 8000,
      gravity: 'bottom',   // `top` or `bottom`
      positionLeft: false, // `true` or `false`
    };

    const breakpoint = 658;   // scrollWidth to take in count the overflow slides
    this.pageWidth = window.matchMedia(`(min-width: ${breakpoint}px)`);
  }

  // Init function will run after BaseComponent Constructor
  init(component) {}


  createToast(message = 'Changes saved', color, duration, closeOption = true) {
    if(!!message) {
        this.options.text = message;
        if (!!color)      this.options.backgroundColor = color;
        if (!closeOption) this.options.close = false;
        if (!!duration)   this.options.duration = duration;

        Toastify(this.options).showToast();
    }
  }

}

export default Toast;
